import React, { useState, ReactNode, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface Tab {
  label: string;
  content: ReactNode;
}

interface TablesToggleProperties {
  tabs?: Tab[]; // ✅ optional
  defaultActive?: string;
  rightContent?: ReactElement;
  children?: ReactNode; // ✅ fallback content
}

/**
 * Tables toggle component
 * @param {any} param0 - The param0
 * @param {any} param0.tabs - The tabs prop
 * @param {any} param0.defaultActive - The defaultActive prop
 * @param {any} param0.rightContent - The rightContent prop
 * @param {any} param0.children - The children prop
 */
function TablesToggle({
  tabs = [],
  defaultActive,
  rightContent,
  children,
}: TablesToggleProperties) {
  const { i18n } = useTranslation();
  const hasTabs = tabs.length > 0;
  const [activeIndex, setActiveIndex] = useState(() => {
    if (defaultActive && hasTabs) {
      const index = tabs.findIndex((tab) => tab.label === defaultActive);
      return index !== -1 ? index : 0;
    }
    return 0;
  });

  return (
    <div className="toggle-tabs-wrapper" dir={i18n.dir()}>
      {/* Header only if tabs or right content exist */}
      {(hasTabs || rightContent) && (
        <div className="toggle-tab-container">
          {hasTabs && (
            <div className="toggle-tabs">
              {tabs.map((tab, index) => (
                <button
                  type="button"
                  key={index}
                  className={`toggle-tab ${activeIndex === index ? 'active' : ''}`}
                  onClick={() => setActiveIndex(index)}>
                  {tab.label}
                </button>
              ))}
            </div>
          )}

          {rightContent && <div className="toggle-right-content">{rightContent}</div>}
        </div>
      )}

      {/* Content */}
      <div className="toggle-content">{hasTabs ? tabs[activeIndex]?.content : children}</div>
    </div>
  );
}

export default TablesToggle;

TablesToggle.defaultProps = {
  tabs: [],
  defaultActive: '',
  rightContent: null,
  children: null,
};
